import { ACTOR_NAMESPACE } from './CsSeqShapeFactory';

/**
 * Converts buildSequenceShape() output into mermaid `sequenceDiagram` source
 * text — box-per-namespace grouping, one arrow per message (calls AND their
 * matching returns, interleaved — see CsSeqShapeFactory.buildEventRows).
 * The synthetic external-caller participant (ACTOR_NAMESPACE) renders as
 * mermaid's `actor` (stick figure), no surrounding `box`/`end`, matching the
 * canvas rendering. Boundary steps (event handlers/catchers, or a target
 * type outside the parsed files) use a dashed arrow with a "(boundary)"
 * suffix instead of being silently dropped. Returns use mermaid's dashed
 * `-->>` too, labeled with the return type if it has one (skipped for
 * void/unknown).
 * @param {{boxes: {namespace: string, participants: string[]}[], messages: {from: string, to: string, method: string, boundary: boolean, isReturn: boolean}[]}} shape
 * @returns {string} mermaid sequenceDiagram source
 */
export function buildMermaidSequence(shape) {
  const lines = ['sequenceDiagram'];

  shape.boxes.forEach(function renderBox(box) {
    if (box.namespace === ACTOR_NAMESPACE) {
      box.participants.forEach(function renderActor(name) {
        lines.push(`  actor ${name}`);
      });
      return;
    }
    lines.push(`  box ${box.namespace}`);
    box.participants.forEach(function renderParticipant(name) {
      lines.push(`    participant ${name}`);
    });
    lines.push('  end');
  });

  shape.messages.forEach(function renderMessage(message) {
    const arrow = message.boundary || message.isReturn ? '-->>' : '->>';
    const suffix = message.boundary ? ' (boundary)' : '';
    // Multi-line ProducesResponseType labels (see CsProducesResponseScanner) joined
    // with ", " here — mermaid message text is a single line, no \n support.
    const methodText = message.method ? message.method.replace(/\n/g, ', ') : '';
    const label = methodText ? `: ${methodText}${suffix}` : '';
    lines.push(`  ${message.from}${arrow}${message.to}${label}`);
  });

  return lines.join('\n');
}
